require('./view-screenshare-template.html');
require('./view-screenshare.style.less');
require('./session-ended-tooltip-template.html');

var browser = require('../../common/browser');
var generateUUID = require('../../common/uuid');

var storage = window.sessionStorage;

angular.module('bbl.module.view-screenshare', [])
.config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/view-screen/:token', {
		templateUrl: 'view-screenshare-template.html',
		controller: 'ViewScreenshareController',
		joinCallRoute: true,
		invitedLayout: true,
		particularBrand: true,
		resolve: { userInfo: ["Auth", function(Auth) {
		  return Auth.getUserInfo().catch(angular.noop);
		}]},
	});
}])
.controller('ViewScreenshareController', [
	'$scope', '$location', '$routeParams', '$http', 'connect', 'sharer', 'watchCon', '$timeout', 'userInfo', 'Api', 'modals', '$intercom', 'RTC_SIGNAL_HOST', 'Toast', '$templateCache', 'CallManager', 'gtmJS', 'simplePeerAuthGuard', 'PusherUpdates', 'PusherPubsub',
	ViewScreenshareController
]);

function ViewScreenshareController($scope, $location, $params, $http, connect, sharer, watchCon, $timeout, userInfo, Api, modals, $intercom, RTC_SIGNAL_HOST, Toast, $templateCache, CallManager, gtmJS, peerAuthGuard, PusherUpdates, PusherPubsub) {
	var search = $location.search();

  $scope.rtcSupport = Boolean(window.RTCPeerConnection);
  $scope.browser = browser;
  $scope.connectData = {};
  $scope.authError = null;
  $scope.authenticating = false;

  $scope.bridge = {
    id: search.bid,
		callUuid: search.cuuid,
		room: location.hostname+'/'+$params.token,
    pinRestrict: search.bid === '1054' || search.restrictPin,
	};

	$scope.conn = {};

  $scope.streams = {
    all: [],
    active: null,
  };

  PusherUpdates.initConnection();
  PusherUpdates.subscribeToChannel($scope.bridge.id, 'call');

  var userCanShare = !!userInfo;
  sharer.canShare().then(function(res) {
    $scope.state.extError = res ? res.code : null;
  }, function() {
    $scope.state.extError = 'cant-share';
  });

	$scope.state = angular.extend({
		step: 'setup',
		owner: false,
    canShare: userCanShare,
    extError: null,
    loggedIn: userInfo,
		userData: userInfo ? {
			username: userInfo.first_name+' '+userInfo.last_name || userInfo.email,
		} : { $id: generateUUID() },
	}, JSON.parse(storage.getItem('screnshare.state') || '{}'));

  var peerConn$ = connect($scope.bridge.room, $scope.state.userData);

  var authGuard;
  if ($scope.bridge.pinRestrict) {
    authGuard = peerAuthGuard(peerConn$, $scope.bridge.room);
  }

	$scope.sendFeedback = function(rating, feedback) {
    $http.post(RTC_SIGNAL_HOST+'feedback', {
      rating: rating,
      comment: feedback,
      bridge: $scope.bridge.id,
      user: $scope.state.userData.username,
      owner: $scope.state.owner,
    });
	};

  $scope.setActiveStream = function(stream) {
    $scope.streams.active = null;

    $timeout(function() {
      $scope.streams.active = stream;
    });
  };

  function getActiveStream(call) {
    return call.streams.filter(function(s) {
      if(s.active) {
        return true;
      }

      // firefox appears to not have MediaStream.active, so, find a way
      return s.getTracks().filter(function(t) {
        return t.readyState !== 'ended';
      }).length > 0;
    })[0];
  }

  $scope.getCallers = function() {
    return peerConn$.calls.keys().filter(function(id) {
      return true;
      // return conn.calls.get(id).active;
    }).map(function(id) {
      var call = peerConn$.calls.get(id),
        peer = peerConn$.peers.get(id);

      return {
        call: call, peer: peer,
        userData: peer.data.user || {},
        getStream: getActiveStream.bind(0, call),
      };
    });
  };

  $scope.connect = function(data, authData) {
    $scope.authError = null;
    if ($scope.bridge.pinRestrict && !authData && !$scope.state.userData.username) {
      $scope.authenticating = true;
      return authGuard.login(data.pin).then(function(user) {
        $scope.connect(null, {username: user.name, pin: user.pin});
      }, function(err) {
        $scope.authError = err;
        disconnect();
      }).then(function() {
        $scope.authenticating = false;
      });
    }

    $scope.state.userData = angular.merge({}, $scope.state.userData, data || authData);

    // update profile for the peer connection
    var conn = connect($scope.bridge.room, $scope.state.userData);

    var isMaster = function() {
      var peer = conn.peers.values()[0];
      return !peer || conn.isMaster(peer.id);
    };

		watchCon(conn, function(ev, callers, peerId) {
      if(ev === 'callStarted') {
        $intercom.trackEvent('screensharing_used');
      }

      $scope.state[ev] = !$scope.state[ev];
      $scope.callers = callers;

      $scope.isLocalSharing = !!conn.getLocalStreams().filter(function(s) { return s.active; })[0];

      var streams = [].concat({
        stream: null,
        username: $scope.state.userData.username
      }).concat(callers.map(function(c) {
        // userData
        return {stream: c.getStream(), username: c.userData.username};
      })).filter(function(c) {
        return c.stream && c.stream.active;
      });

      if (!angular.equals($scope.streams.all, streams)) {
        [].splice.bind($scope.streams.all, 0, 9999).apply(null, streams);

        var active = $scope.streams.active;
        var isActive = active && active.active && !!active.getTracks().filter(function(t) {return t.active;}).length;
        $scope.setActiveStream(isActive ? active : (streams[0] || {}).stream);
      }

			$timeout(angular.noop);
      var isSharing = $scope.state.sharing === true;
			if(ev === 'sharing' && !isSharing && $scope.state.owner && !$scope.state.gotfeedback) {
        Toast.notify(
          $templateCache.get('session-ended-tooltip-template.html'),
          {persistent: true, data: {sendFeedback: $scope.sendFeedback}}
        );

        $scope.state.gotfeedback = true;
        storage.setItem('screnshare.state', JSON.stringify($scope.state));
      }

      if (isMaster() && ['callStarted', 'sharing'].indexOf(ev) > -1) {
        conn.send('/callstart', {bridge: $scope.bridge.id, company: $scope.bridge.company});
      }

      if (ev === 'sharing' && isMaster()) {
        var peer = (callers.filter(function(p) { return (p.peer || {}).id === peerId; })[0] || {}).peer || {};
        var user = (peer.data || {}).user || {};
        conn.send('/ev', {type: 'isSharing', value: isSharing, timestamp: Date.now(), username: user.username});
      }

      if (ev === 'sharing' && isSharing) {
        gtmJS.push($scope.isLocalSharing ? gtmJS.events.SCREENSHARE_SHARER : gtmJS.events.SCREENSHARE_VIEWER);
      }
    });

    setInterval(function() {
      if (!conn.calls.values().length) {conn.send('/sping');}
    }, 10000);

		$scope.state.step = 'view';
		storage.setItem('screnshare.state', JSON.stringify($scope.state));

    return conn;
	};

	if($scope.state.userData && $scope.state.step === 'view') {
		$scope.connect($scope.state.userData);
	}

	$scope.getParticipants = function() {
		var participants = ($scope.getCallers() || []).filter(function(caller) {
			var userData = caller.userData;
      return userData.username || userData.name;
    }).map(function(caller) {
			var userData = caller.userData,
				username = userData.username || userData.name;

			return username + (caller.getStream() ? ' (screensharing)' : '');
		});

    return [$scope.state.userData.username+'*'].concat(participants);
	};

	if (userInfo) {
		Api.bridges.fetchOne($scope.bridge.id).then(function() {
      $scope.state.owner = true;
      $scope.state.canShare = true;
		});
	}

	$http.get('/bridges/api/v1/get-token-data/' + $params.token + '/?format=json')
		.then(function(response) {
			var data = response.data, call = data.call;

			$scope.bridge = angular.extend($scope.bridge, {
				bridge_number: call.number || call.bridge_number,
				company: call.company_name,
				friendly_number: call.friendly_number,
				date: call.date,
				plivo_username: call.plivo_username,
				plivo_password: call.plivo_password,
				brand_logo: (call.brand_logo || 'assets/images/logo@2x.png'),
				brand_tagline: call.bridge_title || call.bridge_description || call.brand_tagline,
        service_provider: call.service_provider,
        jfb_url: call.jfb_url,
        trialPlan: call.company_plan_trial,
			});

      CallManager.init(call.plivo_username, call.plivo_password);

      $scope.$root.particularBrandLogo = data.brand_logo;
      $scope.$root.particularBrandTagline = data.brand_tagline;

      $scope.confReady = true;
      $scope.startConference = CallManager.createCall.bind(0, $scope.bridge);
      $scope.getCall = CallManager.getCall.bind(0);
    });

  if ($scope.bridge.pinRestrict) {
    subscribe(PusherPubsub, PusherPubsub.types.CALLER_BOOTED, function(data) {
      if (data.callerPin+'' !== $scope.state.userData.pin+'') {
        return;
      }

      disconnect();
    });
  }

  function disconnect() {
    $scope.state.step = 'setup';
    $scope.state.userData = {};
    // peerConn$.close();
    storage.setItem('screnshare.state', JSON.stringify($scope.state));
  }

  function subscribe(serv, topic, fn) {
    var subj = serv.sub(topic, fn),
      unsub = subj && subj.unsub && typeof subj.unsub === 'function' ? subj.unsub : angular.noop;

    $scope.$on('$destroy', unsub);
  }
}

require('./toolbar');
require('./chat');
require('./slideshare');



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/view-screenshare/view-screenshare.module.js
 ** module id = 388
 ** module chunks = 0
 **/